// extracted by mini-css-extract-plugin
module.exports = {"sm":"719px","md":"1199px"};